import VueRouter from 'vue-router'
import Home from './pages/Home.vue'
import Login from './pages/Login.vue'
import Register from './pages/Register.vue'
import PageNotFound from './pages/PageNotFound.vue'
import store from './store'; // path to your Vuex store

const router =  new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: { 
                guest: true
            }
        },
        {
            path: '/logout',
            name: 'logout',
            meta: { 
                requiresAuth: true
            },
            beforeEnter (to, from, next) {
                store.dispatch('auth/logout').then( () => {
                    next({ name: 'login' })
                })
            }
        },
        {
            path: '/',
            beforeEnter (to, from, next) {
                next({ name: 'login' })
            }
        },
        { path: "*", component: PageNotFound }
    ]
})

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.auth.loggedIn){
            store.dispatch('auth/getMe').then((u) => {
                if (to.name != "register" && u.state == "UNREGISTERED") next({ name: 'register' });
                else if(to.name == "register" && u.state != "UNREGISTERED") next({ name: 'login' });
                else 
                    next();
            })
        }
        else {
            next({ name: 'login' })
        }
    } 
    else if(to.matched.some(record => record.meta.guest)) {
        if (store.state.auth.loggedIn)
            next({ name: 'home' });
        else
            next()
    } 
    else {
        next() 
    }
})

export default router
